import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import UserDetailsContext from '../context/userDetails.context.js';




function PrivateRoute({ component: Component, ...rest }) {
    const { token } = useContext(UserDetailsContext);

    return (
        <Route {...rest} render={(props) =>
            token.length > 0
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        } />
    );
}

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js